import type { State, Action } from './typings'

import { openDialogProducer, closeDialogProducer } from './actions'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'openDialog':
      return openDialogProducer(state, action.payload)
    case 'closeDialog':
      return closeDialogProducer(state)
  }
}
